import React from "react";
import RenderResourcesVideos from "./RenderResoursesVideos";

const gaVideos = [
  {
    name: "Accessing the Portal",
    link: "https://www.loom.com/embed/c47fc3df56c942408bcc38e3a2da7e37?sid=b23fbd43-5a9c-4746-860a-364b75c15c03",
  },
  {
    name: "Dashboard Overview",
    link: "https://www.loom.com/embed/724f9a5607454ef5838095096fa9bf30",
  },
  {
    name: "Adding and Managing Individuals",
    link: "https://www.loom.com/embed/3a78c3f3fa024d6ab6f5829db02f465f",
  },
  {
    name: "Enrollment Process for Individuals",
    link: "https://www.loom.com/embed/21cbc5c723d649c690cca9a3905dac6c",
  },
  {
    name: "Adding an Employer Group",
    link: "https://www.loom.com/embed/04104ca7621146bfa7c8ab23a1806a50",
  },
  {
    name: "Adding Brokers",
    link: "https://www.loom.com/embed/3e53b9c3e08d4971bd39037c654c470e",
  },
  {
    name: "Sign up Process for Brokers",
    link: "https://www.loom.com/embed/792aea6d515b469ba4cb2c259e3bfcb6",
  },
];

const GaResources = () => {
  return <RenderResourcesVideos resourcesVideos={gaVideos} />;
};

export default GaResources;
